import { prefetchModelIndex } from '@rhino-project/core/hooks';
import { createFileRoute } from '@tanstack/react-router';
import SeasonPlayersPage from '../../../../../../pages/players/SeasonPlayersPage';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/players/'
)({
  loader: ({ context: { rhino }, params: { team_season_id } }) =>
    prefetchModelIndex(rhino, 'player', {
      defaultFilter: {
        rosters: { team_season_id, roster_status: { status_type: 'active' } }
      }
    }),
  component: RouteComponent
});

function RouteComponent() {
  return <SeasonPlayersPage />;
}
